import { useEffect } from 'react';
import { useAuth } from '../../../contexts/AuthProvider';
import { RestApi } from '../../../services/rest-api';
import { Button, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { IField } from '../../../interfaces/field.interface';
import { useUtility } from '../../../contexts/UtilityContext';
import { Fields } from '../../../components/Fields';
import { YES_NO_OPTIONS } from '../../../constants/config';
import { ColorModel } from '../../../model/color.model';

interface IOwnProps {
  color?: ColorModel;
  onSuccess: (color: ColorModel) => void;
}

export const ColorForm: React.FC<IOwnProps> = (props) => {
  const { authInfo } = useAuth();
  const { showLoader, hideLoader, toast } = useUtility();

  const fields: Array<IField> = [
    {
      label: "Color Name",
      required: true,
      props: {
        name: "color_name",
        type: "text",
        inputMode: "text",
        placeholder: "Color Name",
      }
    }, {
      label: "Publish",
      required: true,
      props: {
        name: "publish",
        type: "select",
        placeholder: "Publish"
      },
      options: YES_NO_OPTIONS,
    }
  ];

  const { register, control, handleSubmit, reset } = useForm<ColorModel>({
    defaultValues: {},
    mode: "onTouched",
    reValidateMode: "onChange"
  });

  useEffect(() => {
    async function fetchData() {
      try {
        if (props.color) {
          showLoader();
          reset({
            ...props.color,
          });
        }
      } catch (err) {
        console.log(err);
      } finally {
        hideLoader();
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.color, reset]);

  const onSubmit = handleSubmit(async (inputs) => {
    try {
      showLoader();
      const res = await RestApi<ColorModel>('post', props.color?.id ? 'updateColor' : 'createColor', {
        ...inputs,
        ...(props ? { id: props.color?.id } : {}),
      }, authInfo.user.authorization);

      props.onSuccess(res);

    } catch (message) {
      toast(message, 'danger');
    } finally {
      hideLoader();
    }
  });

  return (
    <Form onSubmit={onSubmit} noValidate>
      <div>
        <Fields<ColorModel> fields={fields} control={control} register={register} />
      </div>
      <Button className='w-100 mt-3' variant='primary' type="submit">Submit</Button>
    </Form>
  );
};